import React, { ReactNode } from 'react';
import { TimePicker } from 'antd';
import { TimePickerProps as TimePickerCopyProps } from 'antd/lib/time-picker';

export type TimePickerProps = TimePickerCopyProps & {
  children?: ReactNode;
};

const ProTimePicker: React.FC<TimePickerProps> = React.forwardRef<
  any,
  TimePickerProps
>((props, ref) => {
  const { children, ...resProps } = props;

  return <TimePicker ref={ref} {...resProps} />;
});

export default ProTimePicker;
